import React from 'react';
import { Routes, Route, Navigate, useParams } from 'react-router-dom';
import Landing from './components/Landing';
import SignIn from './components/SignIn';
import SignUp from './components/SignUp';
import Home from './components/Home';
import CreateProtocol from './components/CreateProtocol';
import UserPage from './components/UserPage';
import ProtocolReport from './components/ProtocolReport';
import InsightsIndex from './components/InsightsIndex';
import Messages from './components/Messages';
import ChecklistPage from './components/ChecklistPage';
import FeedbackPage from './components/FeedbackPage';
import NotificationsPage from './components/NotificationsPage';
import CetarusAccountPage from './components/CetarusAccountPage';
import AuthCallback from './components/AuthCallback';
import ResetPassword from './components/ResetPassword';
import TermsOfService from './components/TermsOfService';
import PrivacyPolicy from './components/PrivacyPolicy';
import About from './components/About';
import ProtectedRoute from './components/ProtectedRoute';
import { UserProtocolStatusProvider } from './contexts/UserProtocolStatusContext';
import { UnloggedCountProvider } from './contexts/UnloggedCountContext';
import './index.css';
import './styles/icons.css';

function UserPageWithId() {
  const { id } = useParams();
  return <UserPage userId={id} />;
}

function App() {
  return (
    <div className="App">
      <UserProtocolStatusProvider>
      <UnloggedCountProvider>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/signin" element={<SignIn />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/about" element={<About />} />
        <Route path="/home" element={<ProtectedRoute><Home /></ProtectedRoute>} />
        <Route path="/dashboard" element={<ProtectedRoute><Home /></ProtectedRoute>} />
        <Route path="/protocols/create" element={<ProtectedRoute><CreateProtocol /></ProtectedRoute>} />
        <Route path="/user" element={<ProtectedRoute><UserPage /></ProtectedRoute>} />
        <Route path="/user/:id" element={<ProtectedRoute><UserPageWithId /></ProtectedRoute>} />
        <Route path="/insights" element={<ProtectedRoute><InsightsIndex /></ProtectedRoute>} />
        <Route path="/insights/protocol-report" element={<ProtectedRoute><ProtocolReport /></ProtectedRoute>} />
        <Route path="/messages" element={<ProtectedRoute><Messages /></ProtectedRoute>} />
        <Route path="/checklist" element={<ProtectedRoute><ChecklistPage /></ProtectedRoute>} />
        <Route path="/feedback" element={<ProtectedRoute><FeedbackPage /></ProtectedRoute>} />
        <Route path="/notifications" element={<ProtectedRoute><NotificationsPage /></ProtectedRoute>} />
        <Route path="/account" element={<ProtectedRoute><CetarusAccountPage /></ProtectedRoute>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      </UnloggedCountProvider>
      </UserProtocolStatusProvider>
    </div>
  );
}

export default App; 